import { ClearIndicatorProps, components } from 'react-select';

import { Icon } from 'components/Icon';

import { OptionType } from './Select.types';

export function ClearIndicator(props: ClearIndicatorProps<OptionType>) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.ClearIndicator {...props}>
      <Icon name="close" size={12} />
    </components.ClearIndicator>
  );
}
